<div class="sr-only">
  <label for="emai" class="sr-only">Real users skip this field</label>
  <input id="emai" type="text" name="emai" class="sr-only" tabindex="-1" />
</div>
